var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-wrapper"
  }, [_vm._m(0), !_vm.forgotPassword && !_vm.resetPasswordSetNewOne ? _c('form', {
    attrs: {
      "id": "login-form"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', [_c('div', {
    staticClass: "svg-icon svg habitica-logo",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.habiticaIcon)
    }
  })])]), _c('div', {
    staticClass: "form-group row text-center"
  }, [_c('div', {
    staticClass: "col-12 col-md-12"
  }, [_c('div', {
    staticClass: "btn btn-secondary social-button",
    on: {
      "click": function ($event) {
        return _vm.socialAuth('google');
      }
    }
  }, [_c('div', {
    staticClass: "svg-icon social-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.googleIcon)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.registering ? _vm.$t('signUpWithSocial', {
    social: 'Google'
  }) : _vm.$t('loginWithSocial', {
    social: 'Google'
  })) + " ")])])])]), _c('div', {
    staticClass: "form-group row text-center"
  }, [_c('div', {
    staticClass: "col-12 col-md-12"
  }, [_c('div', {
    staticClass: "btn btn-secondary social-button",
    on: {
      "click": function ($event) {
        return _vm.socialAuth('apple');
      }
    }
  }, [_c('div', {
    staticClass: "svg-icon social-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.appleIcon)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.registering ? _vm.$t('signUpWithSocial', {
    social: 'Apple'
  }) : _vm.$t('loginWithSocial', {
    social: 'Apple'
  })) + " ")])])])]), _c('div', {
    staticClass: "strike"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('or')))])]), _vm.registering ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.username,
      expression: "username"
    }],
    staticClass: "form-control input-with-error",
    class: {
      'input-valid': _vm.usernameValid,
      'input-invalid': _vm.usernameInvalid
    },
    attrs: {
      "id": "usernameInput",
      "type": "text",
      "placeholder": _vm.$t('usernamePlaceholder')
    },
    domProps: {
      "value": _vm.username
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.username = $event.target.value;
      }
    }
  }), _vm._l(_vm.usernameIssues, function (issue) {
    return _c('div', {
      key: issue,
      staticClass: "input-error"
    }, [_vm._v(" " + _vm._s(issue) + " ")]);
  })], 2) : _vm._e(), !_vm.registering ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.username,
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "usernameInput",
      "type": "text",
      "placeholder": _vm.$t('emailOrUsername')
    },
    domProps: {
      "value": _vm.username
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.username = $event.target.value;
      }
    }
  })]) : _vm._e(), _vm.registering ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "form-control",
    class: {
      'input-invalid': _vm.emailInvalid,
      'input-valid': _vm.emailValid
    },
    attrs: {
      "id": "emailInput",
      "type": "email",
      "placeholder": _vm.$t('emailPlaceholder')
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.email = $event.target.value;
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), !_vm.registering ? _vm._m(5) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "form-control",
    class: {
      'input-invalid input-with-error': _vm.registering && _vm.passwordInvalid,
      'input-valid': _vm.registering && _vm.passwordValid
    },
    attrs: {
      "id": "passwordInput",
      "type": "password",
      "placeholder": _vm.$t(_vm.registering ? 'passwordPlaceholder' : 'password')
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.password = $event.target.value;
      }
    }
  }), _vm.passwordInvalid && _vm.registering ? _c('div', {
    staticClass: "input-error"
  }, [_vm._v(" " + _vm._s(_vm.$t('minPasswordLength')) + " ")]) : _vm._e()]), _vm.registering ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.passwordConfirm,
      expression: "passwordConfirm"
    }],
    staticClass: "form-control input-with-error",
    class: {
      'input-invalid': _vm.passwordConfirmInvalid,
      'input-valid': _vm.passwordConfirmValid
    },
    attrs: {
      "id": "confirmPasswordInput",
      "type": "password",
      "placeholder": _vm.$t('confirmPasswordPlaceholder')
    },
    domProps: {
      "value": _vm.passwordConfirm
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.passwordConfirm = $event.target.value;
      }
    }
  }), _vm.passwordConfirmInvalid ? _c('div', {
    staticClass: "input-error"
  }, [_vm._v(" " + _vm._s(_vm.$t('passwordConfirmationMatch')) + " ")]) : _vm._e(), _vm._m(7)]) : _vm._e(), _c('div', {
    staticClass: "text-center"
  }, [_vm.registering ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "submit",
      "disabled": _vm.signupFormInvalid
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('joinHabitica')) + " ")]) : _vm._e(), !_vm.registering ? _vm._m(8) : _vm._e(), _c('div', {
    staticClass: "toggle-links"
  }, [_vm.registering ? _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      },
      "exact": "exact"
    }
  }, [_vm._m(9)]) : _vm._e(), !_vm.registering ? _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      },
      "exact": "exact"
    }
  }, [_vm._m(10)]) : _vm._e()], 1)])]) : _vm._e(), _vm.forgotPassword ? _c('form', {
    attrs: {
      "id": "forgot-form"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._m(11), _c('div', [_c('div', {
    staticClass: "svg-icon habitica-logo",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.habiticaIcon)
    }
  })]), _c('div', {
    staticClass: "header"
  }, [_vm._m(12), _vm._m(13)])]), _c('div', {
    staticClass: "form-group row text-center"
  }, [_vm._m(14), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.username,
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "usernameInput",
      "type": "text",
      "placeholder": _vm.$t('emailUsernamePlaceholder')
    },
    domProps: {
      "value": _vm.username
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.username = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "text-center"
  }, [_vm._m(15)])]) : _vm._e(), _vm.resetPasswordSetNewOne ? _c('form', {
    attrs: {
      "id": "reset-password-set-new-one-form"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', [_c('div', {
    staticClass: "svg-icon habitica-logo color",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.habiticaIcon)
    }
  })]), _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('passwordResetPage')))])])]), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "form-control input-with-error",
    class: {
      'input-invalid': _vm.passwordInvalid,
      'input-valid': _vm.passwordValid
    },
    attrs: {
      "id": "passwordInput",
      "type": "password",
      "placeholder": _vm.$t('password')
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.password = $event.target.value;
      }
    }
  }), _vm.passwordInvalid ? _c('div', {
    staticClass: "input-error"
  }, [_vm._v(" " + _vm._s(_vm.$t('minPasswordLength')) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.passwordConfirm,
      expression: "passwordConfirm"
    }],
    staticClass: "form-control input-with-error",
    class: {
      'input-invalid': _vm.passwordConfirmInvalid,
      'input-valid': _vm.passwordConfirmValid
    },
    attrs: {
      "id": "confirmPasswordInput",
      "type": "password",
      "placeholder": _vm.$t('confirmPasswordPlaceholder')
    },
    domProps: {
      "value": _vm.passwordConfirm
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.passwordConfirm = $event.target.value;
      }
    }
  }), _vm.passwordConfirmInvalid ? _c('div', {
    staticClass: "input-error"
  }, [_vm._v(" " + _vm._s(_vm.$t('passwordConfirmationMatch')) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-info",
    attrs: {
      "enabled": !_vm.resetPasswordSetNewOneData.hasError
    },
    on: {
      "click": function ($event) {
        return _vm.resetPasswordSetNewOneLink();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('setNewPass')) + " ")])])]) : _vm._e(), _c('div', {
    class: `bottom-wrap-${!_vm.registering ? 'login' : 'register'}`,
    attrs: {
      "id": "bottom-wrap"
    }
  }, [_vm._m(18)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "top-background"
    }
  }, [_c('div', {
    staticClass: "seamless_stars_varied_opacity_repeat"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "usernameInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('username')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "usernameInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('emailOrUsername')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "emailInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('email')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "passwordInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('password')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "float-right forgot-password",
    on: {
      "click": function ($event) {
        _vm.forgotPassword = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('forgotPassword')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "confirmPasswordInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('confirmPassword')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('small', {
    staticClass: "form-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('termsAndAgreement'))
    }
  });
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('login')) + " ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "toggle-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('alreadyHaveAccountLogin'))
    }
  });
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "toggle-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('dontHaveAccountSignup'))
    }
  });
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "svg-icon gryphon"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', [_vm._v(" " + _vm._s(_vm.$t('emailNewPass')) + " ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v(" " + _vm._s(_vm.$t('forgotPasswordSteps')) + " ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "usernameInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('emailOrUsername')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn btn-info",
    on: {
      "click": function ($event) {
        return _vm.forgotPasswordLink();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sendLink')) + " ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "passwordInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('newPass')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "confirmPasswordInput"
    }
  }, [_vm._v(_vm._s(_vm.$t('confirmPass')))]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "bottom-background"
    }
  }, [_c('div', {
    staticClass: "seamless_mountains_demo_repeat"
  }), _c('div', {
    staticClass: "midground_foreground_extended2"
  })]);

}]

export { render, staticRenderFns }